// eslint-disable-next-line max-len
var USER_INTERFACE_ARROW_04_LEFT = 'M25.05,29.8a1.26,1.26,0,1,1-1.68,1.88L7,16.94a1.26,1.26,0,0,1,0-1.88L23.37.32h0A1.26,1.26,0,1,1,25.05,2.2L9.68,16Z';

export { USER_INTERFACE_ARROW_04_LEFT };
//# sourceMappingURL=USER_INTERFACE_ARROW_04_LEFT.js.map
